export enum FireRiskEnum {
	NONE = 'NAO_ESPECIFICADO',
	SMALL = 'PEQUENO',
	MEDIUM = 'MEDIO',
	HIGH = 'ALTO',
	HIGHEST = 'MUITO_ALTO',
}
